import moment from 'moment-timezone'
import React from 'react'
import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'

import { Opportunity, OpportunityApiResponse } from 'Event/interfaces'
import useFormatToOrgTime from 'Event/scenes/events/hooks/useFormatToOrgTime'
import { getSlots } from 'Event/scenes/events/helpers/volunteerSlots'

interface EventListTableProps {
  events: Partial<OpportunityApiResponse>[]
}

const useStyles = makeStyles({
  empty: {
    textAlign: 'center',
    padding: '24px',
    color: '#999',
    fontStyle: 'italic',
  },
})

export const EventListTable: React.FC<EventListTableProps> = ({ events }: EventListTableProps) => {
  const classes = useStyles()
  const formatTime = useFormatToOrgTime()

  if (!events || events.length === 0) {
    return <div className={classes.empty}>No events</div>
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>ID</TableCell>
          <TableCell>Opp ID</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Start</TableCell>
          <TableCell>End</TableCell>
          <TableCell>Roles</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.map((event, idx) => {
          const slots = event.slots || getSlots(event as unknown as Opportunity)

          return (
            <TableRow key={idx}>
              <TableCell>{event.occurrenceId}</TableCell>
              <TableCell>{event.opportunityId}</TableCell>
              <TableCell>{moment(event.startsAt).format('M/D/YY')}</TableCell>
              <TableCell>{event.name}</TableCell>
              <TableCell>{formatTime(event.startsAt)}</TableCell>
              <TableCell>{formatTime(event.endsAt)}</TableCell>
              <TableCell>
                {slots.total - slots.available} / {slots.total}
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
